import React from "react";
import { object } from "prop-types";

import { optionsType } from "../../prop-types";
import "./buttonSelectScoring.css";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value,
  );
};

const FormikButtonSelectScoring = ({
  options,
  field,
  allDisabled,
  form: { setFieldValue },
}) => {
  const value = getValue(options, field);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base = `d-flex justify-content-around selectable-button-scoring align-items-center ${
      option.isDisabled || allDisabled ? "disabled " : " "
    }`;
    if (!value.length) {
      return base;
    }

    if (option.value === value[0].value) {
      return base + "active-selectable-button-scoring";
    }
    return base;
  };

  return (
    <div className="selectable-button-scoring-box">
      {options.map((option, i) => {
        return (
          <div
            key={i}
            className={getClassName(option)}
            color="primary"
            outline
            onClick={
              option.isDisabled || allDisabled
                ? () => {}
                : () => handleChange(option)
            }
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

FormikButtonSelectScoring.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default FormikButtonSelectScoring;



// WEBPACK FOOTER //
// ./src/components/formik/ButtonSelectScoring.jsx